import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    isNIFNumberShowed: false,
    fiscalCode: '999999990',
};
export const reducer = createReducer(initialState, (builder) => {
    builder.addCase(actions.setNIFNumberShowed, (state, { payload }) => ({
        ...state,
        isNIFNumberShowed: payload,
    }));
});
